/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The types of connection:
 *   * CONSUMPTION
 *   * PRODUCTION
 */
export enum EnedisConnectionType {
  CONSUMPTION = 'CONSUMPTION',
  PRODUCTION = 'PRODUCTION'
}
